exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ReactVirtualized__Table__headerRow {\n    border-radius: 7px 7px 0 0;\n    border: 0.5px solid #d4d4d4;\n    border-bottom: none;\n}", ""]);

